import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface AdminRouteProps {
  children?: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { hasPermission, isLoading } = useUserPermissions();
  
  // Show loading while checking permissions
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // Check for market compass admin permission
  if (!hasPermission('market_compass.admin')) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children || <Outlet />}</>;
};